import BuyerItemPrimary from "./buyerItemPrimary";
import BuyerItemSecondary from "./buyerItemSecondary";
// import { Buyer } from "@genericTypes/sharedTypes";
import { GQLOffers } from "@gql/types/gql";
export default function BuyerItem({
    buyer,
    index,
    categoryId,
}: {
    buyer: GQLOffers;
    index: number;
    categoryId: number;
}) {
    return (
        <section
            className=" flex mb-8 flex-col "
            itemScope
            itemType="https://schema.org/Offer"
        >
            <BuyerItemPrimary
                buyer={buyer}
                index={index}
                categoryId={categoryId}
            />
            <BuyerItemSecondary buyer={buyer} categoryId={categoryId} />
        </section>
    );
}
